import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import Logo from "./Logo";
import { site } from "@/config/site";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-navy text-white mt-0" data-testid="site-footer">
      <div className="mx-auto max-w-site px-5 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <Logo variant="dark-bg" width={160} />
            <p className="mt-5 text-brand-mist max-w-md leading-relaxed">
              {site.tagline}
            </p>
            <p className="mt-4 text-brand-pale text-sm max-w-md leading-relaxed">
              Set it up once. We take care of the rest.
            </p>
          </div>

          <div>
            <h4 className="text-brand-light font-bold mb-4 text-sm uppercase tracking-wider">Site</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/" className="text-brand-pale hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/how-it-works" className="text-brand-pale hover:text-white transition-colors">How it works</Link></li>
              <li><Link to="/pricing" className="text-brand-pale hover:text-white transition-colors">Pricing</Link></li>
              <li><Link to="/faq" className="text-brand-pale hover:text-white transition-colors">FAQ</Link></li>
              <li><Link to="/contact" className="text-brand-pale hover:text-white transition-colors">Contact</Link></li>
              <li>
                <a
                  href={site.customerPortalUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-brand-pale hover:text-white transition-colors inline-flex items-center gap-1.5"
                  data-testid="footer-login"
                >
                  Customer Login <span aria-hidden="true">↗</span>
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-brand-light font-bold mb-4 text-sm uppercase tracking-wider">Legal</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/privacy" className="text-brand-pale hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to="/privacy#your-rights" className="text-brand-pale hover:text-white transition-colors" data-testid="footer-data-request-link">Data Access &amp; Deletion</Link></li>
              <li><Link to="/terms" className="text-brand-pale hover:text-white transition-colors">Terms &amp; Conditions</Link></li>
              <li><Link to="/refund-policy" className="text-brand-pale hover:text-white transition-colors">Refund &amp; Cancellation</Link></li>
              <li><Link to="/service-delivery" className="text-brand-pale hover:text-white transition-colors">Service Delivery</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 grid grid-cols-1 md:grid-cols-3 gap-6 text-sm">
          <div className="flex items-start gap-3">
            <Phone className="h-4 w-4 text-brand-light mt-0.5 shrink-0" strokeWidth={1.75} />
            <a href={`tel:${site.phoneTel}`} className="text-brand-pale hover:text-white" data-testid="footer-phone">
              {site.phoneDisplay}
            </a>
          </div>
          <div className="flex items-start gap-3">
            <Mail className="h-4 w-4 text-brand-light mt-0.5 shrink-0" strokeWidth={1.75} />
            <a href={`mailto:${site.email}`} className="text-brand-pale hover:text-white" data-testid="footer-email">
              {site.email}
            </a>
          </div>
          <div className="flex items-start gap-3">
            <MapPin className="h-4 w-4 text-brand-light mt-0.5 shrink-0" strokeWidth={1.75} />
            <address className="not-italic text-brand-pale leading-relaxed">
              {site.address.line1}<br />
              {site.address.line2}
            </address>
          </div>
        </div>

        <p className="mt-10 pt-6 border-t border-white/10 text-xs text-brand-pale/60">
          © {year} {site.brandName}. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
